module.exports = __webpack_public_path__ + "img/gulerodsmuffins_dej.df98b09d.jpg";